import {
    ACTION_GET_HAPPINESS_TIPS_CATEGORIES,
    ACTION_POST_CREATE_HAPPINESS_TIPS_CATEGORIES,
    ACTION_PUT_UPDATE_HAPPINESS_TIPS_CATEGORIES,
    ACTION_DELETE_HAPPINESS_TIPS_CATEGORIES,
    SET_HAPPINESS_TIPS_CATEGORIES
} from "./types/types.js";

// Aseg�rate de que en @/services est� exportado como TipsCategoriesService
import { TipsCategoriesService } from "@/services";
import i18n from '@/plugins/i18n';
import Swal from 'sweetalert2';

const actions = {
    [ACTION_GET_HAPPINESS_TIPS_CATEGORIES]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                TipsCategoriesService.getHappinessTips(idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp && resp.data && resp.data.data) {
                            commit(SET_HAPPINESS_TIPS_CATEGORIES, resp.data.data);
                            resolve(resp);
                        } else {
                            reject(new Error('Invalid response format'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_HAPPINESS_TIPS_CATEGORIES]: ({ state }, category) => {
        const data = {
            happinessCategoryTipsName: category.happinessCategoryTipsName,
            status: category.status !== undefined ? category.status : true
        };

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                // CAMBIO: createTip -> createHappinessTip
                TipsCategoriesService.createTip(idEmpresa, idUsuario, data)
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: i18n.t('happinessTips.actionPostCreateCategories.success'),
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                        } else {
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_UPDATE_HAPPINESS_TIPS_CATEGORIES]: ({ state }, category) => {
        const data = {
            happinessCategoryTipsName: category.happinessCategoryTipsName,
            status: category.status !== undefined ? category.status : true
        };

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                TipsCategoriesService.updateTip(idEmpresa, idUsuario, category.categoryId, data)
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: i18n.t('happinessTips.actionPutUpdateCategories.success'),
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                        } else {
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_DELETE_HAPPINESS_TIPS_CATEGORIES]: ({ state }, formData) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                TipsCategoriesService.deleteTip(idEmpresa, idUsuario, formData.happinessCategoryTipsId)
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: i18n.t('happinessTips.actionDeleteCategories.success'),
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                        } else {
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
};

export default actions;